export default __webpack_public_path__ + "static/media/ion_earth.2fa3d08e.svg";